/* oxlint-disable react/only-export-components -- compound-object component namespace (verified true false-positive): observed dev-server HMR 2026-07-17 — module hot-updated at its own refresh boundary, no invalidate, page state preserved; see FE-755 */
import type { ReactNode } from 'react'
import { Field as BaseField } from '@base-ui/react/field'
import * as R from 'remeda'

import { cn } from '@gto/ui/cn'
import { HelpIconTooltip } from '@gto/ui/components/help-icon-tooltip'
import type { TooltipProps } from '@gto/ui/tooltip'

import { fieldVariants } from './field.styles'

const styles = fieldVariants()

const Root = ({ className, ...props }: BaseField.Root.Props) => {
  return (
    <BaseField.Root
      className={cn(styles.root(), className)}
      {...props}
    />
  )
}

type LabelProps = BaseField.Label.Props & {
  tooltip?: ReactNode
  tooltipProps?: Pick<TooltipProps, 'className' | 'hoverable' | 'placement'>
}

const Label = ({ className, tooltip, tooltipProps, ...props }: LabelProps) => {
  return (
    <BaseField.Label
      className={cn(styles.label(), className)}
      {...props}
    >
      {props.children}
      {R.isNonNullish(tooltip) && (
        <HelpIconTooltip
          embedded
          content={tooltip}
          {...tooltipProps}
        />
      )}
    </BaseField.Label>
  )
}

const Error = ({ className, ...props }: BaseField.Error.Props) => {
  return (
    <BaseField.Error
      className={cn(styles.error(), className)}
      {...props}
    />
  )
}

export const Field = {
  Root,
  Label,
  Error,
  Description: BaseField.Description,
  Control: BaseField.Control,
} as const
